// Abhi's version
import React, { useState } from "react";
import "../../style/HomePageContents.css"; // Ensure styles are properly applied

const HomePageContents = () => {
  const [link, setLink] = useState("");

  const handleChange = (event) => {
    setLink(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // alert(`Link submitted: ${link}`);
  };

  return (
    <div className="homePageContainer">
      <form className="linkForm" onSubmit={handleSubmit}>
        <input
          type="url"
          value={link}
          onChange={handleChange}
          placeholder="Input a job link here: https://example.com"
          required
          className="inputField"
        />
        <button type="submit" className="submitButton">
          Submit
        </button>
      </form>
    </div>
  );
};

export default HomePageContents;
